import { EQuizMode } from '@constants';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizResultService = sdk.getService('QuizResultService');

export const useAllMyQuizResultByMode = (modes: EQuizMode[]) => {
  const { isLoading, data, isFetching, refetch } = useQuery({
    queryKey: ['quiz-results-all-by-mode', modes],
    enabled: Array.isArray(modes) && modes.length > 0,
    queryFn: async () => QuizResultService.getAllQuizResultByQuizMode(modes)
  });

  return {
    isLoading,
    isFetching,
    quizResults: data ?? [],
    refetch
  };
};
